<template>
  <div>
    <v-overlay :value="isProcessing">
      <v-progress-circular
        indeterminate
        color="primary"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
    <VerifyCodeDialog
      :verificationType="emailVerificationType"
      :contactInfo="emailOnFile"
      :showDialog="showAuthorizeCodeModal"
      :onClose="() => showAuthorizeCodeModal = false"
      :onSuccess="processMembershipLinking"
    />

    <v-row justify="center">
      <v-col lg="6" md="5" class="pb-0 hidden-sm-and-down">
        <v-img class="sticky-image" height="100vh" :src="linkAccountImage" />
      </v-col>
      <v-col class="link-to-membership-by-code" lg="6" md="7" sm="12">
        <h1>Look up membership</h1>
        <p>You need to find your membership record to properly link your existing data (dogs, kennels, litters, etc.) to a web account.</p>
        <p><strong>The membership has to be linked before creating a new web account.</strong></p>

        <v-form v-model="isValid">
          <v-text-field
            outlined
            placeholder="Member ID"
            type="text"
            v-model="memberId"
            :rules="[(v) => !!v || 'Member ID is required']"
          />
          <v-text-field
            outlined
            placeholder="First name"
            type="text"
            v-model="firstName"
            :rules="[(v) => !!v || 'First name is required']"
          />
          <v-text-field
            outlined
            placeholder="Last name"
            type="text"
            v-model="lastName"
            :rules="[(v) => !!v || 'Last name is required']"
          />
          <v-alert
            width="100%"
            v-if="!!errorMessage"
            dismissible
            type="error"
          >{{ errorMessage }}</v-alert>
        </v-form>

        <p><strong>We will confirm your identity by sending a verification code to the email address you provided to ASCA.</strong></p>
        <p>If you can't find your record or no longer have access to the contact email, please contact the ASCA Business Office at <a href="mailto:support@asca.org">support@asca.org</a>.</p>

        <v-btn
          :dark="isValid"
          large
          color="primary"
          v-on:click="validateMemberData"
          :disabled="!isValid"
        >Email me the code</v-btn>

        <router-link to="/signup">Skip, I've never been an ASCA member</router-link>

        <div class="footer-container">
          <v-img height="2rem" contain :src="logoImage" />
          <footer-text />
        </div>
      </v-col>
    </v-row> 
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import FooterText from '@/components/common/FooterText.vue';
import VerifyCodeDialog from '@/components/common/VerifyCodeDialog.vue';
import authenticationService from "@/services/authenticationService";
import { VerificationType } from "@/services/codeVerificationService";
import { UserInfo } from "@/types/User";

const logoImage = require('@/assets/logo.svg');
const linkAccountImage = require('@/assets/link-account.png');

export default Vue.extend({
  components: { FooterText, VerifyCodeDialog },
  name: 'LinkUserToMembershipByCode',
  data() {
    return {
      linkAccountImage,
      logoImage,
      isProcessing: false,
      errorMessage: '',
      showAuthorizeCodeModal: false,
      isValid: false,
      memberId: '',
      firstName: '',
      lastName: '',
      emailOnFile: '',
    };
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    emailVerificationType: function () {
      return VerificationType.Email;
    }
  },
  created: function() {  
      localStorage.removeItem("membershipLinkPersonId");
      localStorage.removeItem("membershipLinkIsJunior");
      localStorage.removeItem("membershipLinkJuniorBirthdate");
  },
  methods: {
    validateMemberData: async function() {
        this.isProcessing = true;

        const response = await authenticationService.verifyMembership(this.memberId, this.firstName, this.lastName);

        if(!!response.id && !!response.email) {
          this.emailOnFile = response.email;
          this.errorMessage = '';
          this.isProcessing = false;
          this.showAuthorizeCodeModal = true;
          
          localStorage.setItem("membershipLinkPersonId", response.id);

          if(!!response.isJunior){
            localStorage.setItem("membershipLinkIsJunior", response.isJunior);
            localStorage.setItem("membershipLinkJuniorBirthdate", response.juniorBirthDate);
          }
        } else {
          this.errorMessage = !!response.messages ? response.messages.join(', ') : '';
          this.isProcessing = false;
        }
    },
    processMembershipLinking: async function() {
      this.$router.push('/signupMember');
    },
  },
});
</script>
